const Developer = () => {
    return <section id="developer" className="w-full flex h-14 border-t border-gray-200 bg-white">
        <font className="w-fit h-fit my-auto mx-auto"> {new Date().getFullYear()} &copy; Jilo Innovations</font>
    </section>
}

export default Developer;